import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	NgbDatepickerModule,
	NgbTooltipModule,
	NgbModalModule,
	NgbTypeaheadModule,
	NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { SortablejsModule, SortablejsDirective } from 'angular-sortablejs';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NavigationModule } from './navigation/navigation.module';
import { FormElementsModule } from './form-elements/form-elements.module';
import { TableModule } from './table/table.module';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { StepperComponent } from './stepper/stepper.component';
/**
 * SharedModule exists to make commonly used components, directives,
 * and pipes available for use in the templates of components throughout
 * the application.
 */
@NgModule({
	declarations: [StepperComponent],
	imports: [
		CommonModule,
		FormElementsModule,
		NgSelectModule,
		/* SortablejsModule.forRoot({}), */ CdkTableModule,
		CdkStepperModule,
		// Add ng-bootstrap modules we want to use
		NgbTooltipModule,
		NgbDatepickerModule,
		NgbModalModule,
		NgbTypeaheadModule,
		NgbNavModule,
		FormsModule,
		NavigationModule,
		TableModule,
		ReactiveFormsModule,
		AngularEditorModule,
	],
	exports: [
		CommonModule,
		FormElementsModule,
		NgSelectModule,
		/* SortablejsDirective ,*/ CdkTableModule,
		// Add ng-bootstrap modules we want to use
		NgbTooltipModule,
		NgbDatepickerModule,
		NgbModalModule,
		NgbTypeaheadModule,
		NgbNavModule,
		FormsModule,
		NavigationModule,
		TableModule,
		ReactiveFormsModule,
		AngularEditorModule,
		CdkStepperModule,
		StepperComponent,
	],
})
export class SharedModule {}
